import React from 'react';
import { STYLES } from '../consts';
import { FormWrapper } from './form/FormWrapper';
import { BillInfo } from './BillInfo';
import { BillDocumentContainer } from './BillDocumentContainer';

interface IProps {
    shouldShowImageContainer: boolean;
}

export const CreateBillBody = ({ shouldShowImageContainer }: IProps) => (
  <div className={STYLES.CREATE_BILL_BODY.WRAPPER}>
    {shouldShowImageContainer ? <BillDocumentContainer /> : <BillInfo />}
    <FormWrapper />
  </div>
);
